import gql from 'graphql-tag';
import { useMutation } from '@apollo/react-hooks';

const RESEND_EMAIL_VERIFICATION_CODE = gql`
  mutation resendEmailVerificationCode($firebaseId: String!) {
    resendEmailVerificationCode(firebaseId: $firebaseId) {
      message
      success
    }
  }
`;
export function useResendEmailVerificationLinkMutation() {
  return useMutation(RESEND_EMAIL_VERIFICATION_CODE);
}
const VERIFY_EMAIL = gql`
  mutation verifyEmail($firebaseId: String!, $verificationCode: String!) {
    verifyUserEmail(
      firebaseId: $firebaseId
      verificationCode: $verificationCode
    ) {
      message
      success
      user {
        firstName
        lastName
        email
        phone
        company
        profilePicUrl
        userType
        emailVerification {
          completed
        }
        firebaseId
      }
    }
  }
`;
export function useEmailVerificationMutation() {
  return useMutation(VERIFY_EMAIL);
}
